import React from "react";
import { Form } from "react-bootstrap";

// Style agar teks tidak bisa di-block/select
const noSelectStyle = {
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
    cursor: "default",
};

const boxStyle = {
    ...noSelectStyle,
    maxHeight: "260px",
    overflowY: "auto",
    border: "1px solid #ced4da",
    borderRadius: "4px",
    padding: "15px 20px",
    fontSize: "0.9rem",
    lineHeight: "1.6",
    background: "#fff",
};

// Dipakai untuk list a, b, c, ...
const alphaListStyle = {
    listStyleType: "lower-alpha",
    paddingLeft: "20px",
};

// Dipakai untuk sub-list angka 1, 2, 3, ... di dalam poin a-q
const decimalListStyle = {
    listStyleType: "decimal",
    paddingLeft: "20px",
};

const preventEvent = (e) => e.preventDefault();

const UserAgreement = ({ checked, onChange }) => {
    return (
        <div className="user-agreement mb-5">
            <h4 className="mb-3">User Agreement</h4>
            <p>
                Pengguna diwajibkan untuk membaca seluruh persyaratan yang diajukan oleh
                BPPMHKP. Bacalah User Agreement berikut dengan seksama dan teliti, bila
                pengguna sudah menyetujui seluruh persyaratan yang diajukan oleh BPPMHKP
                silahkan centang <strong>checkbox</strong> persetujuan kemudian klik tombol{" "}
                <strong>SUBMIT</strong>.
            </p>

            <div
                style={boxStyle}
                onCopy={preventEvent}
                onCut={preventEvent}
                onPaste={preventEvent}
                onContextMenu={preventEvent}
                onDragStart={preventEvent}
            >
                <p className="text-center">
                    <strong>USER AGREEMENT</strong>
                </p>

                <p>
                    Layanan Aplikasi SIAPMUTU merupakan Pelayanan online sistem
                    pelayanan Permohonan Sertifikasi Layanan Mutu yang dilakukan oleh
                    Unit Pelaksana Teknis PPMHKP. Dalam proses perizinan sertifikasi
                    mutu di Indonesia, layanan aplikasi BPPMHKP sudah terintegrasi
                    dalam portal INSW.
                </p>

                <p>
                    Portal INSW merupakan Sistem elektronik yang ter-integrasi secara
                    nasional, yang dapat diakses melalui jaringan Internet
                    (public-network), yang akan melakukan integrasi informasi
                    berkaitan dengan proses penanganan dokumen kepabeanan dan dokumen
                    lain yang terkait dengan ekspor-impor, yang menjamin keamanan data
                    dan informasi serta memadukan alur dan proses informasi antar
                    sistem internal secara otomatis, yang meliputi sistem kepabeanan,
                    perizinan, kepelabuhanan/kebandarudaraan, dan sistem lain yang
                    terkait dengan proses pelayanan dan pengawasan kegiatan
                    ekspor-impor.
                </p>

                <p>
                    Layanan <strong>online Sistem Aplikasi Mutu (SIAPMUTU) BPPMHKP</strong>{" "}
                    dapat diakses melalui http://siapmutu.kkp.go.id{" "}
                    <strong>melalui jaringan internet umum</strong>. Dengan mengakses
                    atau menggunakan seluruh layanan dari BPPMHKP, pengguna setuju
                    untuk terikat dengan syarat-syarat dan ketentuan yang diatur di
                    bawah ini.
                </p>

                <p className="mb-1">
                    <strong>1. LISENSI</strong>
                </p>
                <ol style={alphaListStyle}>
                    <li>
                        BPPMHKP memiliki hak cipta terhadap layanan{" "}
                        <strong>aplikasi SIAPMUTU BPPMHKP</strong>.
                    </li>
                    <li>
                        Perjanjian Lisensi User Agreement ini dibuat dan efektif oleh
                        dan antara BPPMHKP ("Penyedia layanan") dan Pengguna ("Pemakai
                        layanan").
                    </li>
                    <li>
                        BPPMHKP memiliki hak untuk membuat ketentuan sebagai syarat
                        yang wajib dipatuhi pengguna untuk dapat menggunakan layanan
                        aplikasi BPPMHKP.
                    </li>
                    <li>
                        User Agreement ini tidak memerlukan tanda tangan dan cap basah
                        ataupun disaksikan oleh notaris.
                    </li>
                    <li>
                        User Agreement ini dapat berubah sewaktu-waktu tanpa
                        pemberitahuan sebelumnya kepada pengguna.
                    </li>
                </ol>

                <p className="mb-1">
                    <strong>2. REGISTRASI</strong>
                </p>
                <ol style={alphaListStyle}>
                    <li>
                        Untuk dapat menggunakan layanan aplikasi, pengguna wajib
                        mendaftar dan melakukan registrasi secara online pada alamat
                        http://siapmutu.kkp.go.id dengan mengisi web form registrasi.
                    </li>
                    <li>
                        Pengguna diwajibkan mengisi data-data yang lengkap, akurat dan{" "}
                        <strong>
                            terbaru termasuk data Nama Perusahaan, NPWP Perusahaan, NIB,
                            Alamat Perusahaan, Data Penanggung Jawab, serta UPT KIPM
                            tempat sertifikasi
                        </strong>
                        . BPPMHKP tidak bertanggung jawab jika terjadi permasalahan
                        karena kesalahan pengisian data registrasi.
                    </li>
                    <li>
                        Pada saat mengisi form registrasi, pengguna wajib mengupload
                        semua dokumen yang dipersyaratkan.
                    </li>
                    <li>
                        Petugas akan melakukan verifikasi dan dapat menerima atau
                        menolak permohonan registrasi. Jika diterima, maka pengguna
                        akan menerima pemberitahuan akun login aplikasi melalui email.
                    </li>
                </ol>

                <p className="mb-1">
                    <strong>3. BATAS KEWAJIBAN</strong>
                </p>
                <ol style={alphaListStyle}>
                    <li>
                        BPPMHKP menjamin kerahasiaan seluruh data registrasi yang
                        diisi oleh pengguna layanan. BPPMHKP tidak akan memberikan
                        informasi tersebut kepada pihak manapun.
                    </li>
                    <li>
                        BPPMHKP tidak bertanggung jawab atas User ataupun Password
                        yang hilang atas hacking, keylogger, penipuan ataupun
                        kelalaian Pengguna. Pengguna bertanggung jawab atas
                        kerahasiaan User dan Password sendiri, yaitu:
                        <ol style={decimalListStyle}>
                            <li>User Pengguna</li>
                            <li>Password Pengguna</li>
                        </ol>
                        Adalah data yang harus disimpan sebaik-baiknya.
                    </li>
                    <li>
                        BPPMHKP tidak bertanggung jawab atas email pengguna yang
                        hilang atas hacking, keylogger, penipuan ataupun kelalaian
                        pengguna. Pengguna bertanggung jawab atas kerahasiaan User dan
                        Password email sendiri.
                    </li>
                    <li>
                        Pengguna juga diminta melakukan tindakan preventif dalam
                        melindungi dan menjaga kestabilan Sistem Operasi, keamanan
                        data komputer serta ID pengguna sendiri. BPPMHKP tidak
                        bertanggung jawab atas kerusakan ataupun kerugian yang terjadi
                        karena virus, spyware ataupun usaha hacking dari pihak lain
                        untuk mengambil data anda.
                    </li>
                </ol>

                <p className="mb-1">
                    <strong>4. PEMBAYARAN</strong>
                </p>
                <ol style={alphaListStyle}>
                    <li>
                        Pengguna tidak dipungut bayaran untuk menggunakan Aplikasi{" "}
                        <strong>Registrasi SIAPMUTU</strong>.
                    </li>
                    <li>
                        Besar tarif yang dikeluarkan sesuai dengan{" "}
                        <strong>
                            Peraturan Pemerintah Nomor 85 Tahun 2021 Tentang Tarif Atas
                            Jenis Penerimaan Negara Bukan Pajak Yang Berlaku Pada
                            Kementerian Kelautan Dan Perikanan, dan Peraturan Menteri Keuangan Republik Indonesia Nomor 1 Tahun 2025 
                            Tentang jenis dan tarif atas jenis penerimanan negara bukan pajak yang bersifa
                            volatil yang berlaku pada Kementerian Kelautan dan Perikanan
                        </strong>
                        .
                    </li>
                </ol>

                <p className="mb-1">
                    <strong>5. KESEPAKATAN LAYANAN</strong>
                </p>
                <ol style={alphaListStyle}>
                    <li>
                        Aplikasi <strong>SIAPMUTU BPPMHKP</strong> dapat diakses 1 x 24
                        jam serta 7 hari dalam seminggu.
                    </li>
                    <li>
                        Pengguna tidak akan menuntut BPPMHKP terkait dengan
                        maintenance rutin maupun kejadian yang membuat penggunaan
                        Aplikasi <strong>SIAPMUTU BPPMHKP</strong> terhenti baik yang
                        dikarenakan gangguan teknis maupun nonteknis.
                    </li>
                    <li>
                        Apabila terjadi permasalahan dalam pemberian jasa layanan
                        kepada para pelanggan, BPPMHKP berhak membatasi atau bahkan
                        memberhentikan layanan sewaktu-waktu tanpa keharusan
                        memberikan pemberitahuan terlebih dulu. BPPMHKP dapat
                        memberikan penjelasan mengenai permasalahan tersebut sesuai
                        dengan kebijakan BPPMHKP.
                    </li>
                    <li>
                        Pengguna Aplikasi <strong>SIAPMUTU BPPMHKP</strong> diwajibkan
                        mengisi data dengan benar dan sesuai dengan konten. BPPMHKP
                        berhak memberikan sanksi atau bahkan memblok ID pengguna yang
                        mengisi data tidak sesuai dengan konten. Kegagalan pengguna
                        dalam hal melakukan mengisi data bukan merupakan tanggung
                        jawab BPPMHKP.
                    </li>
                    <li>
                        Pengguna bertanggung jawab atas segala tindakan, perkataan,
                        pesan maupun tulisan yang disampaikan, baik di dalam FAQ
                        maupun ke dalam pesan yang disampaikan ke layanan aplikasi,
                        baik melalui email maupun penyampaian pesan langsung yang ada
                        di bawah layanan BPPMHKP.
                    </li>
                    <li>
                        Anda setuju untuk membebaskan BPPMHKP beserta seluruh
                        stafnya dan pihak lain yang bekerja sama dengan BPPMHKP dari
                        tuntutan dan kerugian yang timbul karena tindakan, tingkah
                        laku dan pesan yang dituliskan ataupun penyampaian langsung
                        oleh pengguna di dalam email ataupun helpdesk layanan kami.
                    </li>
                    <li>
                        Pengguna tidak diperbolehkan melakukan usaha untuk
                        mendapatkan keuntungan dengan memanfaatkan layanan yang
                        diberikan oleh BPPMHKP.
                    </li>
                    <li>
                        Elemen yang terkandung di dalam aplikasi yang
                        dipublikasikan oleh BPPMHKP adalah milik BPPMHKP.
                    </li>
                    <li>
                        BPPMHKP tidak bertanggung jawab atas kehilangan yang terjadi
                        atas kelalaian pengguna, berkaitan dengan ID pengguna ataupun
                        isi yang terdapat di dalam ID tersebut.
                    </li>
                    <li>
                        Kegagalan login pengguna melalui fasilitas Single Sign ON
                        (SSO) baik melalui Aplikasi <strong>SIAPMUTU BPPMHKP</strong>{" "}
                        maupun melalui aplikasi yang terintegrasi pada SSO bukan
                        merupakan tanggung jawab BPPMHKP.
                    </li>
                    <li>
                        BPPMHKP tidak bertanggung jawab atas kehilangan ID pengguna
                        layanan lain yang telah terintegrasi melalui fasilitas Single
                        Sign ON (SSO) dengan Aplikasi <strong>SIAPMUTU BPPMHKP</strong>.
                    </li>
                    <li>
                        Untuk memenuhi percepatan arus data layanan aplikasi BPPMHKP
                        telah terintegrasi dengan layanan Single Sign ON (SSO).
                        Kehilangan User dan password layanan lain yang telah
                        terintegrasi Single Sign ON (SSO) dengan Aplikasi{" "}
                        <strong>SIAPMUTU BPPMHKP</strong> bukan merupakan tanggung
                        jawab BPPMHKP.
                    </li>
                    <li>
                        Pengguna tidak diperbolehkan untuk membuat, mendistribusikan,
                        menjual-belikan segala produk yang merupakan hak
                        paten/hak cipta layanan aplikasi tanpa ijin resmi dari
                        BPPMHKP.
                    </li>
                    <li>
                        Pengguna diwajibkan untuk menaati peraturan layanan yang
                        telah ditentukan oleh BPPMHKP. BPPMHKP berhak memberikan
                        sanksi atau bahkan memblok ID pengguna yang melanggar
                        peraturan layanan.
                    </li>
                    <li>
                        BPPMHKP tidak membenarkan penyalahgunaan kesalahan sistem.
                        Apabila pengguna terbukti secara sadar dan sengaja
                        memanfaatkan kesalahan pada sistem yang terdapat pada
                        layanan aplikasi maka BPPMHKP akan memberikan sanksi yang
                        sesuai.
                    </li>
                    <li>
                        BPPMHKP dapat melakukan perubahan di sub site Aplikasi{" "}
                        <strong>SIAPMUTU BPPMHKP</strong>, peraturan dan User
                        Agreement yang ada untuk meningkatkan kualitas layanan yang
                        diberikan, tanpa harus melakukan pemberitahuan terlebih
                        dulu. Kami menganjurkan para pelanggan untuk rutin
                        mengunjungi website BPPMHKP ataupun Aplikasi{" "}
                        <strong>SIAPMUTU BPPMHKP</strong> untuk mendapatkan
                        berita-berita terbaru.
                    </li>
                    <li>
                        Bila diperlukan, BPPMHKP berhak untuk mengambil tindakan
                        hukum terhadap pelanggaran User Agreement ini ataupun
                        terhadap tindakan yang dianggap merugikan perusahaan selaku
                        pemegang hak cipta atas jasa layanan.
                    </li>
                </ol>

                <p>
                    6. Pengguna harus menyimpan salinan User Agreement ini untuk
                    catatan.
                </p>
                <p>
                    7. BPPMHKP tidak bertanggung jawab terhadap tindakan penipuan atau
                    tindakan lain sejenisnya yang mengatasnamakan BPPMHKP.
                </p>
            </div>

            <Form.Check className="mt-3">
                <Form.Check.Input
                    className="me-2"
                    type="checkbox"
                    id="userAgreementCheck"
                    checked={checked}
                    onChange={onChange}
                    required
                />
                <Form.Check.Label htmlFor="userAgreementCheck">
                    Saya sudah membaca dan menyetujui
                </Form.Check.Label>
            </Form.Check>
        </div>
    );
};

export default UserAgreement;